<template>
 <!--
    	作者：kmdshop
    	时间：2019-10-26
    	描述：门店-店员列表-修改店员
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--店员修改-->
      <div class="common-form">店员修改</div>
      <el-form-item label="所属门店">
        <el-select v-model="form.store_id" placeholder="请选择">
          <el-option v-for="(item,index) in storeList" :key="index" :label="item.store_name" :value="item.store_id"></el-option>
        </el-select>
        <div>
          <el-link :underline="false" disabled>请选择店员所属的门店，用于核销订单</el-link>
        </div>
      </el-form-item>
      <el-form-item label="店员姓名" prop="real_name" :rules="[{required: true,message: ' '}]">
        <el-input class="max-w460" v-model="form.real_name" placeholder="请输入店员姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile" :rules="[{required: true,message: ' '}]">
        <el-input class="max-w460" v-model="form.mobile" placeholder="请输入手机号"></el-input>
      </el-form-item>

      <el-form-item label="年龄" prop="age" :rules="[{required: true,message: '请输入年龄'}]">
        <el-input class="max-w460" v-model="form.age" type="number" placeholder="请输入年龄"></el-input>
      </el-form-item>
      <el-form-item label="等级" prop="grade" :rules="[{required: true,message: '请设置等级'}]">
        <el-input class="max-w460" v-model="form.grade"  placeholder="请设置等级"></el-input>

        <div style="color: gray;">例如：金牌、银牌等，前端可根据这个进行筛选</div>
      </el-form-item>

      <el-form-item label="服务内容" prop="service" :rules="[{required: true,message: '请设置服务内容'}]">
        <el-input class="max-w460" v-model="form.service"  placeholder="请设置服务内容(可逗号隔开)"></el-input>

        <div style="color: gray;">例如：语音聊天、文字聊天等，多个请用逗号(英文逗号,)隔开（只用于筛选）</div>
      </el-form-item>

      <el-form-item label="选择性别">
        <el-select v-model="form.gender" placeholder="请选择">
          <el-option  label="女" :value="0"></el-option>
          <el-option  label="男" :value="1"></el-option>
        </el-select>
        <div>
          <el-link :underline="false" disabled>选择后不可更改</el-link>
        </div>
      </el-form-item>   

      <el-form-item label="微信号" prop="wx_code" :rules="[{required: true,message: '请输入微信号'}]">
        <el-input class="max-w460" v-model="form.wx_code" placeholder="请输入微信号"></el-input>
      </el-form-item>

      <el-form-item label="微信二维码">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('qrcode')">选择图片</el-button>
          <div v-if="form.code!=''" class="img">
            <img :src="form.code" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>


      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!--添加-->
    <GetUser :is_open="open_add" @close="closeDialogFunc($event, 'add')"></GetUser>
      <!--上传图片组件-->
      <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
  import StoreApi from '@/api/store.js';
  import GetUser from '@/components/user/GetUser.vue';
  import { formatModel } from '@/utils/base.js'
  import Upload from '@/components/file/Upload';
  export default {
    components: {
      /*编辑组件*/
      GetUser,
      Upload
    },
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
          clerk_id: null,
          store_id: '',
          status: '',
          real_name: '',
          mobile: '',
          code:"",
          wx_code:"",
          gender:0,
          age:18,
          grade:"",
          service:""
        },

        /*是否打开添加弹窗*/
        open_add: false,
        storeList: [],
        loading: false,
        isupload:false,
        type:1,
      };
    },
    created() {

      this.form.clerk_id=this.$route.query.clerk_id;

      this.getParams()
    },

    methods: {
      
      /*上传*/
      openUpload(e) {
        this.file_type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.form.code = e[0].file_path;
          
        }
        this.isupload = false;
      },

      getParams() {
        let self = this;
        // 取到路由带过来的参数

        StoreApi.clerkDetail({
            clerk_id: self.form.clerk_id
          }, true)
          .then(data => {
            // 将数据放在当前组件的数据内
            self.form = formatModel(self.form, data.data.detail);
            self.form.status = data.data.detail.status.value;
            self.storeList = data.data.store_list;
          })
          .catch(error => {

          });

      },
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            StoreApi.editClerk(form, true)
              .then(data => {
                  self.$message({
                    message: '恭喜你，修改成功',
                    type: 'success'
                  });
                  self.$router.push('/store/clerk/index');
              })
              .catch(error => {
                self.loading = true;
              });
          }
        });
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      }

    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/store/clerk/edit.vue